import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { UliItemAttachmentsFacade } from './uli-item-attachments.facade';
import { loadStoreState, setInitialStoreState } from '../../../../../../../common';

@Injectable({
  providedIn: 'root',
})
export class UliItemAttachmentsGuard {
  constructor(private uliItemAttachmentsFacade: UliItemAttachmentsFacade) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> | boolean {
    return loadStoreState(this.uliItemAttachmentsFacade);
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.uliItemAttachmentsFacade);
  }
}
